import { Component, Prop, Vue } from "vue-property-decorator";
import { configuratorConstants, SelectedOptionsSummaryModuleModel } from "../models";
import { productConfiguratorStore as store } from "./../store";
import Cookie from "@/services/Cookie";
import http from "@/services/Http";
import { EventBus } from "@/events";

@Component
export default class SelectedOptionsSummaryModule extends Vue {

    @Prop()
    protected vm!: SelectedOptionsSummaryModuleModel;
    private url: string = window.location.origin + "/site.axd/Layout/GetSaveProductConfiguratorAndSendUrlModal";
    private selectedConfiguratorProducts: string = "SelectedConfiguratorProducts-";
    private selectedCustomConfiguratorProducts: string = "SelectedCustomConfiguratorProducts-";

    get translations() {
        return store.translations;
    }

    get configuratorValues() {
        return store.configuratorValues.filter(x => x.value && x.valueDescriptions && x.valueDescriptions.length);
    }

    get configuratorValueGroups() {
        let valueDefinedProperties = this.configuratorValues.map(x => x.property.propertyName);
        let valueDefinedPropertiesTemp = valueDefinedProperties.filter(x => x !== configuratorConstants.MaterialConsumptionFactorIndoorWall
            && x !== configuratorConstants.MaterialConsumptionFactorOutdoorWall
            && x !== configuratorConstants.MaterialConsumptionFactorExaktOutdoorWall
            && x !== configuratorConstants.CornerBlockOpeningBlockQuantityFactor
            && x !== configuratorConstants.AdjustmentFactorForNormalBlockPassPicker);

        if (valueDefinedPropertiesTemp.find(x => x === configuratorConstants.InnerCorners) &&
            valueDefinedPropertiesTemp.find(x => x === configuratorConstants.OuterCorners)) {
                valueDefinedPropertiesTemp = valueDefinedPropertiesTemp.filter(x => x !== configuratorConstants.GroundShape);
        } else if (valueDefinedPropertiesTemp.find(x => x === configuratorConstants.GroundShape)) {
            valueDefinedPropertiesTemp = valueDefinedPropertiesTemp.filter(x => x !== configuratorConstants.InnerCorners && x !== configuratorConstants.OuterCorners);
        }

        valueDefinedProperties = valueDefinedPropertiesTemp;
        const groups = store.propertyGroups.filter(x => x.properties.some(prop => valueDefinedProperties.includes(prop.propertyName)));

        return groups.map(group => {
            return {...group, properties: group.properties.filter(property => valueDefinedProperties.includes(property.propertyName))};
          });
    }

    public cookieExists(): boolean {
        return Cookie.cookieExists([this.selectedConfiguratorProducts + store.configuratorType, store.configuratorType + configuratorConstants.ECOProductCookieSuffix]);
    }

    public resetCookie() {
        Cookie.removeCookies([this.selectedConfiguratorProducts +  store.configuratorType, this.selectedCustomConfiguratorProducts + store.configuratorType,
            store.configuratorType + configuratorConstants.ECOProductCookieSuffix]);
        this.$forceUpdate();
        window.location.reload();
    }

    protected getConfiguratorValueDescriptions(propertyName: string) {
        const moduleValue = store.configuratorValues.find(x => x.property.propertyName === propertyName && x.value);
        return moduleValue && moduleValue.value ? moduleValue.valueDescriptions : [];
    }

    protected getHtmlStringWithRowBreaks(input: string) {
        return input.replace(/(?:\r\n|\r|\n)/g, "<br />");
    }

    protected shareConfigurator() {
        if (window.eventBus) {
            EventBus.$emit("shareConfigurator", store.configuratorType);
        }
    }
}
